// EasySell (the COD-form app) doesn't inject its own button into the cart
// drawer on its own, so this relocates its existing button element
// (preserving whatever click handler EasySell attached — moving a real
// DOM node keeps its listeners, unlike creating a copy) into a slot
// inside the drawer's own footer.
//
// The slot lives inside #CartDrawer, which cart.js's renderContents()
// completely replaces from the server on every add-to-cart — so instead
// of trying to survive outside that refresh (which fought the drawer's
// layout and looked wrong), this watches for those refreshes and
// re-populates the slot every time one happens, keeping it correctly
// nested inside the real drawer panel at all times.
(function () {
  // The drawer's whole markup (including the slot) gets replaced wholesale
  // on quantity/remove updates, not just add-to-cart — that destroys the
  // slot's old DOM subtree, taking the real (moved, not cloned) button node
  // down with it. document.getElementById() can't find it afterward because
  // it's gone from the document entirely, so we keep our own reference to
  // the real node here and reuse it instead of re-querying every time.
  var cachedButton = null;

  function isCartEmpty() {
    var cartDrawer = document.querySelector('cart-drawer');
    return !cartDrawer || cartDrawer.classList.contains('is-empty');
  }

  function populateSlot() {
    var slot = document.getElementById('CartDrawer-EasySellSlot');
    if (!slot) return;

    if (isCartEmpty()) {
      slot.innerHTML = '';
      return;
    }

    if (!cachedButton || !document.body.contains(cachedButton)) {
      cachedButton = document.getElementById('es-popup-button') || cachedButton;
    }

    if (cachedButton && !slot.contains(cachedButton)) {
      slot.appendChild(cachedButton);
      cachedButton.style.display = '';
    }
  }

  populateSlot();

  // Re-run whenever #CartDrawer's content is replaced (every add-to-cart)
  // or whenever EasySell creates/recreates its button elsewhere.
  var observer = new MutationObserver(populateSlot);
  observer.observe(document.body, { childList: true, subtree: true });
})();
